// src/api/stocks.js
import apiClient from './client';

export const stocksAPI = {
  async getAll(params = {}) {
    const response = await apiClient.get('/stocks/', { params });
    return response.data;
  },
  
  async getById(id) {
    const response = await apiClient.get(`/stocks/${id}/`);  // ⭐ Fixed
    return response.data;
  },
  
  async adjustQuantity(id, quantity, reason) {
    const response = await apiClient.post(`/stocks/${id}/adjust_quantity/`, {  // ⭐ Fixed
      quantity,
      reason
    });
    return response.data;
  },
  
  async create(stockData) {
    const response = await apiClient.post('/stocks/', stockData);
    return response.data;
  },
  
  async update(id, stockData) {
    const response = await apiClient.patch(`/stocks/${id}/`, stockData);  // ⭐ Fixed
    return response.data;
  },
  
  async delete(id) {
    const response = await apiClient.delete(`/stocks/${id}/`);  // ⭐ Fixed
    return response.data;
  },
};

export default stocksAPI;
